import { QuickScheduleFacade } from '../../facades/quick_schedule_facade';
import { QuickScheduleQuery } from '../../queries/quick_schedule_query';

class QuickScheduleErrorDialog {
  constructor(private ngQuickScheduleQuery: QuickScheduleQuery, private ngQuickScheduleFacade: QuickScheduleFacade) {}
}

angular.module('capability-ng-scheduler').component('quickScheduleErrorDialog', {
  templateUrl:
    'capability-ng-scheduler/src/views/aside/scheduler_navigation/components/quick_schedule_error_dialog/quick_schedule_error_dialog.html',
  controller: QuickScheduleErrorDialog
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/aside/scheduler_navigation/components/quick_schedule_error_dialog/quick_schedule_error_dialog.ts